<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
    components: {BFormGroup, BFormInput},
    props: {
        compact: {
            default: false
        },
        readOnly: {
            default: false,
        },
        value: {
            default: null
        },
        config: {
            type: Object,
            default() {
                return {
                    data: []
                };
            }
        }
    },
    data() {
        return {
            val: this.value,
            timerId: null
        }
    },
    methods: {
        change() {
            clearTimeout(this.timerId);

            this.timerId = setTimeout(() => {
                this.$emit('input', this.val ? parseFloat(this.val) : null)
            }, 1000);
        }
    },
    watch: {
        value() {
            this.val = this.value;
        }
    }
}
</script>

<template>
    <div>
        <div v-if="readOnly">
            <h5>{{ $t('Component(CompositionSubstance):max-concentration') }}</h5>
            <div class="mb-1">{{ value ? value : '-' }}</div>
        </div>
        <div v-else>
            <b-form-group :label="$t('Component(CompositionSubstance):max-concentration')">
                <b-form-input
                    :title="$t('Component(CompositionSubstance):hover-max-concentration')"
                    v-model="val"
                    type="number"
                    @input="change"
                />
            </b-form-group>
        </div>
    </div>
</template>
